import { sendSentryMessage } from '@/lib/sentry/sentry';
import { isProduction } from '@/lib/vercel-env';

export const clarityEvent = (eventName: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (isProduction()) {
    if (window.clarity) {
      window.clarity('event', eventName);
    } else {
      sendSentryMessage('WINDOW_CLARITY_NOT_AVAILABLE_FOR_EVENT');
    }
  }
};
